module.exports = __webpack_public_path__ + "images/b9910780426838d74896196e2cc909a0.svg";